import { defineStore } from 'pinia';

export const useScrollPositionStore = defineStore('scrollPosition', {
  state: () => ({
    positions: {},
    lastPath: null,
    navigationHistory: [] // Keep track of navigation history
  }),
  
  actions: {
    savePosition(path, position) {
      // Don't save tiny scroll positions to avoid unnecessary restorations
      if (position < 10) position = 0;
      
      // Update positions
      this.positions[path] = position;
      this.lastPath = path;
      
      // Add to navigation history
      if (!this.navigationHistory.includes(path)) {
        this.navigationHistory.push(path);
        
        // Keep history manageable
        if (this.navigationHistory.length > 20) {
          this.navigationHistory.shift();
        }
      }
    },
    
    getPosition(path) {
      return this.positions[path] || 0;
    },
    
    getLastPath() {
      return this.lastPath;
    },
    
    getNavigationHistory() {
      return this.navigationHistory;
    },
    
    wasVisitedBefore(path) {
      return this.navigationHistory.includes(path);
    }
  }
});
